import React, { useState } from "react"
import { FaChevronRight } from "react-icons/fa"
import { FaChevronLeft } from "react-icons/fa6"



export default function Preview({ config }) {
    const {
        corGradiente1,
        corGradiente2,
        corGradiente3,
        corCard1,
        corCard2,
        corFonte,
        corFonte2,
        corGradienteBotao1,
        corGradienteBotao2,
        corBotaoHover1,
        corBotaoHover2,
        textoBotaoCor,
        corBotaoSombra,
        logoURL,
        frontURL,
        showLogo,
        corTabelaTitulo,
        corTabelaConteudo,
        logoDiretoClaro,
    } = config
    const [viewLogin, setViewLogin] = useState(true)
    const [hover, setHover] = useState(true)



    return (
        <div className='p-4' style={{ display: 'grid' }}>
            <h5>Prévia</h5>
            <div className="flex justify-center">
                <div style={{ height: '35vh', width: '4vh', backgroundColor: "lightgray", display: "grid", alignContent: "center", cursor: "pointer" }}>
                    <span style={{ height: "35vh", display: "grid", alignContent: "center" }}
                        onClick={() => setViewLogin(prevView => !prevView)}>
                        <FaChevronLeft style={{ fontSize: '4vh', color: "black" }} />
                    </span>
                </div>


                <div
                    style={{
                        gap: '1vh',
                        padding: '4vh',
                        display: viewLogin ? 'flex' : 'none',
                        height: '35vh',
                        width: '60vh',
                        fontSize: '1.2vh',
                        background: `linear-gradient(to top left,#${corGradiente1},#${corGradiente2},#${corGradiente3})`
                    }}>
                    <div style={{ display: "grid", gap: "1vh" }}>
                        <div style={{
                            height: '4vh',
                            width: '35vh',
                            padding: '0.5vh',
                            paddingLeft: '2vh',
                            borderRadius: '7px',
                            overflow: 'auto',
                            backgroundColor: `#${corCard1}`
                        }}>
                            <p
                                style={{
                                    color: `#${corFonte}`
                                }}
                            >
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            </p>
                        </div>
                        <div style={{ display: 'flex', gap: '1vh' }}>
                            <div style={{
                                height: '23vh',
                                width: '26vh',
                                padding: '2vh',
                                borderRadius: '7px',
                                overflow: 'hidden',
                                backgroundColor: `#${corCard1}`
                            }}>
                                <p
                                    style={{
                                        color: `#${corFonte}`
                                    }}
                                >
                                    Débitos:
                                </p>
                                <table>
                                    <thead style={{
                                        backgroundColor:`#${corTabelaTitulo}`,
                                        color: 'whitesmoke'
                                    }}>
                                        <tr>
                                            <th>Descrição</th>
                                            <th>Valor</th>
                                            <th>Vencimento</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{
                                        backgroundColor:`#${corTabelaConteudo}`,
                                        color: 'whitesmoke'
                                    }}>
                                        <tr>
                                            <td>Lorem</td>
                                            <td>R$ 9,99</td>
                                            <td>10/05/2017</td>
                                        </tr>
                                        <tr>
                                            <td>ipsum</td>
                                            <td>R$ 9,99</td>
                                            <td>15/06/2015</td>
                                        </tr>
                                        <tr>
                                            <td>dolor</td>
                                            <td>R$ 99,99</td>
                                            <td>10/07/2007</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div style={{ display: 'grid', gap: '1vh' }}>
                                <div style={{
                                    height: '5vh',
                                    width: '8vh',
                                    padding: '0.5vh',
                                    borderRadius: '7px',
                                    overflow: 'hidden',
                                    backgroundColor: `#${corCard2}`
                                }}>
                                    <img src={logoURL} alt='' style={{ height: '1.4vh' }} />
                                </div>
                                <div style={{
                                    height: '5vh',
                                    width: '8vh',
                                    padding: '0.5vh',
                                    borderRadius: '7px',
                                    overflow: 'hidden',
                                    backgroundColor: `#${corCard1}`
                                }}>
                                    <p
                                        style={{
                                            color: `#${corFonte}`,
                                        }}
                                    >
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                    </p>
                                </div>
                                <div style={{
                                    height: '5vh',
                                    width: '8vh',
                                    padding: '0.5vh',
                                    borderRadius: '7px',
                                    overflow: 'hidden',
                                    backgroundColor: `#${corCard1}`
                                }}>
                                    <p
                                        style={{
                                            color: `#${corFonte}`,
                                        }}
                                    >
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                    </p>
                                </div>
                                <div style={{
                                    height: '5vh',
                                    width: '8vh',
                                    padding: '0.5vh',
                                    borderRadius: '7px',
                                    overflow: 'hidden',
                                    backgroundColor: `#${corCard1}`
                                }}>
                                    <p
                                        style={{
                                            color: `#${corFonte}`,
                                        }}
                                    >
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{
                        display: 'grid',
                        justifyContent: 'center',
                        height: '28vh',
                        width: '20vh',
                        padding: '2vh',
                        borderRadius: '7px',
                        overflowY: 'auto',
                        overflowX: "hidden",
                        backgroundColor: `#${corCard1}`
                    }}>
                        <div style={{
                            height: '7vh',
                            width: '14.5vh',
                            padding: '1vh',
                            borderRadius: '7px',
                            overflow: 'auto',
                            backgroundColor: `#${corCard2}`
                        }}>
                            <p
                                style={{
                                    color: `#${corFonte2}`,
                                    fontSize: "1vh"
                                }}
                            >
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            </p>
                        </div>
                        <div style={{
                            height: '7vh',
                            width: '14.5vh',
                            padding: '1vh',
                            borderRadius: '7px',
                            overflow: 'auto',
                            backgroundColor: `#${corCard2}`
                        }}>
                            <p
                                style={{
                                    color: `#${corFonte2}`,
                                    fontSize: "1vh"
                                }}
                            >
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            </p>
                        </div>
                        <div style={{ alignItems: 'flex-end', display: "grid" }}>
                            <button
                                style={hover ? {
                                    border: '0px',
                                    backgroundImage: `linear-gradient(#${corGradienteBotao1},#${corGradienteBotao2})`,
                                    height: '3.5vh',
                                    width: '14.5vh',
                                    borderRadius: '5px',
                                    color: `#${textoBotaoCor}`,
                                    fontSize: '1.2vh',
                                } : {
                                    border: '0px',
                                    backgroundImage: `linear-gradient(#${corBotaoHover1},#${corBotaoHover2})`,
                                    height: '3.5vh',
                                    width: '14.5vh',
                                    borderRadius: '5px',
                                    color: `#${textoBotaoCor}`,
                                    fontSize: '1.2vh',
                                    boxShadow: `#${corBotaoSombra}85 0.5px 0.5px 2px 2px`
                                }
                                }
                                onClick={() => setHover(prevHover => !prevHover)}
                                type="button"
                            >Continuar</button>
                        </div>
                    </div>
                </div>

                <div style={{
                    display: !viewLogin ? 'flex' : 'none',
                    height: '35vh',
                    width: '60vh',
                    background: `linear-gradient(to bottom right,#${corGradiente1},#${corGradiente2},#${corGradiente3})`
                }}
                >
                    <div style={{
                        display: 'flex',
                        maxWidth: '100%',
                        height: '100%',
                    }}>
                        <div
                            style={{
                                position:'relative',
                                top: '0px',
                                left: '0px',
                                minWidth: '100%',
                                height: '100%',
                                zIndex: '0',
                            }}
                        >
                            <img src={frontURL} alt=''
                            style={{
                                height: '100%',
                                width: '100%',
                            }}
                            />
                        </div>
                        <div
                            style={{
                                position:'relative',
                                top: '0px',
                                left: '-50%',
                                minWidth: '50%',
                                height: '100%',
                                display: "grid",
                                justifyContent: "center",
                                zIndex: '5'
                            }}
                        >
                            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: "2vh" }}>
                                <img src={logoURL} alt='' style={{ height: '3vh' }} />
                            </div>
                            <div style={{
                                height: '15vh',
                                width: '22vh',
                                padding: '0.5vh',
                                borderRadius: '4px',
                                gap: '1vh',
                                overflow: 'hidden',
                                backgroundColor: `#${corCard1}`,
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignSelf: 'center',
                                alignItems: 'center',
                            }}>
                                <p
                                    style={{
                                        color: `#${corFonte}`,
                                        fontSize: '2vh'
                                    }}
                                >
                                    Bem vindo
                                </p>
                                <input style={{  height: "2vh", width: "20vh" }} disabled />
                                <input style={{  height: "2vh", width: "20vh" }} disabled />
                                <button
                                    style={hover ? {
                                        border: '0px',
                                        backgroundImage: `linear-gradient(#${corGradienteBotao1},#${corGradienteBotao2})`,
                                        height: '3.5vh',
                                        width: '14.5vh',
                                        borderRadius: '5px',
                                        color: "snow",
                                        fontSize: '1.2vh',
                                    } : {
                                        border: '0px',
                                        backgroundImage: `linear-gradient(#${corBotaoHover1},#${corBotaoHover2})`,
                                        height: '3.5vh',
                                        width: '14.5vh',
                                        borderRadius: '5px',
                                        color: "snow",
                                        fontSize: '1.2vh',
                                        boxShadow: `#${corBotaoSombra}85 1.5px 1.5px 5px 5px`,
                                    }
                                    }
                                    onClick={() => setHover(prevHover => !prevHover)}
                                    type="button"
                                >Continuar</button>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                {showLogo &&
                                    <img src={logoDiretoClaro ? '/Logo-novo-alt.png' : '/Logo-novo.png'} alt='' style={{ height: '3vh' }} />}
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ height: '35vh', width: '4vh', backgroundColor: "lightgray", cursor: "pointer", zIndex: '5' }}>
                    <span style={{ height: "35vh", display: "grid", alignContent: "center" }}
                        onClick={() => setViewLogin(prevView => !prevView)}>
                        <FaChevronRight style={{ fontSize: '4vh', color: "black", }} />
                    </span>
                </div>

            </div>
        </div>
    )
}